import type { IconType } from '@/types/icon.types';
import { i18n } from '@/common/locale';

import type { StatusCardInfo, StatusColorType, TotalStatusType } from './statusCard.types';

export const TOTAL_CARD: StatusCardInfo<TotalStatusType> = {
  label: '',
  value: 0,
  status: 'total',
  colorType: 'total',
};

export const COLOR_MAP: Record<string, StatusColorType> = {
  active: 'active',
  running: 'active',
  bound: 'active',

  inactive: 'inactive',
  noSignal: 'inactive',
  unknown: 'inactive',
  exited: 'inactive',
  terminated: 'inactive',
  other: 'inactive',
  delete: 'inactive',
  retain: 'inactive',

  normal: 'normal',
  succeeded: 'normal',
  ready: 'normal',
  complete: 'normal',
  available: 'normal',

  warning: 'warning',
  pending: 'warning',
  processing: 'warning',
  notReady: 'warning',
  waiting: 'warning',
  suspended: 'warning',
  released: 'warning',

  critical: 'critical',
  failed: 'critical',
  error: 'critical',
  failureTarget: 'critical',
  terminating: 'critical',
  lost: 'critical',
};

export const STATUS_TITLE_MAP: Record<string, string> = {
  total: 'Total',
  active: 'Active',
  inactive: 'Inactive',
  // GPU Monitoring
  idle: 'Idle',

  // Infrastructure Container
  running: 'Running',
  exited: 'Exited',
  other: 'Other',

  // Database
  noSignal: 'No Signal',

  // K8s Container
  waiting: 'Waiting',
  terminated: 'Terminated',

  // K8s Namespace
  terminating: 'Terminating',

  // K8s Pod
  pending: 'Pending',
  succeeded: 'Succeeded',
  failed: 'Failed',
  unknown: 'Unknown',

  // K8s Node
  ready: 'Ready',
  notReady: 'Not Ready',

  // K8s Jobs
  complete: 'Complete',
  suspended: 'Suspended',
  failureTarget: 'Failure Target',

  // Cloud
  processing: 'Processing',
  error: 'Error',

  // URL Monitoring
  success: i18n.global.t('WORD.SUCCESS'),
  requestError: i18n.global.t('WORD.REQUEST_ERROR'),
  serverError: i18n.global.t('WORD.SERVER_ERROR'),
  unknownError: i18n.global.t('WORD.UNKNOWN_ERROR'),

  // Alert
  normal: 'Normal',
  warning: 'Warning',
  critical: 'Critical',

  // K8s Storage
  bound: 'Bound',
  available: 'Available',
  released: 'Released',
  lost: 'Lost',
  delete: 'Delete',
  retain: 'Retain',
};

export const ALERT_ICON_MAP: Record<string, IconType> = {
  normal: 'icon-fill-check-circle',
  warning: 'icon-fill-warning',
  critical: 'icon-fill-error-circle',
};
